const UNIT_MAP = {
  unit: ["unidad", "unidades"], units: ["unidad", "unidades"],
  unidad: ["unidad", "unidades"], unidades: ["unidad", "unidades"],
  pieza: ["pieza", "piezas"], piezas: ["pieza", "piezas"],
  pza: ["pieza", "piezas"], pzas: ["pieza", "piezas"],
  caja: ["caja", "cajas"], cajas: ["caja", "cajas"],
  rollo: ["rollo", "rollos"], rollos: ["rollo", "rollos"],
  saco: ["saco", "sacos"], sacos: ["saco", "sacos"],
  bulto: ["bulto", "bultos"], bultos: ["bulto", "bultos"],
  metro: ["metro", "metros"], metros: ["metro", "metros"],
  litro: ["litro", "litros"], litros: ["litro", "litros"],
  kg: ["kg", "kg"], m2: ["m²", "m²"], "m²": ["m²", "m²"],
};

export function unitForms(unit) {
  if (!unit) return ["unidad", "unidades"];
  const u = String(unit).trim().toLowerCase();
  if (UNIT_MAP[u]) return UNIT_MAP[u];
  if (u.endsWith("es")) return [u.slice(0, -2), u];
  if (u.endsWith("s")) return [u.slice(0, -1), u];
  return [u, u + "s"];
}

export function unitLabel(qty, unit) {
  const [sg, pl] = unitForms(unit);
  return Number(qty) === 1 ? sg : pl;
}

export function formatQuantity(qty, unit) {
  const n = Number(qty) || 0;
  return `${n} ${unitLabel(n, unit)}`;
}
